import { render } from "./OptStatViewManagerHospitals.vue?vue&type=template&id=011202ab&scoped=true"
import script from "./OptStatViewManagerHospitals.vue?vue&type=script&lang=js"
export * from "./OptStatViewManagerHospitals.vue?vue&type=script&lang=js"

import "./OptStatViewManagerHospitals.vue?vue&type=style&index=0&id=011202ab&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011202ab"]])

export default __exports__